import { useCallback, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { CREATE_ORDER_API, VERIFY_ORDER_API } from "../../services/apiConstants";

const loadRazorpayScript = () => {
  return new Promise((resolve) => {
    // prevent adding script multiple times
    if (document.getElementById("razorpay-script")) {
      resolve(true);
      return;
    }

    const script = document.createElement("script");
    script.id = "razorpay-script";
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.onload = () => resolve(true);
    script.onerror = () => resolve(false);
    document.body.appendChild(script);
  });
};


const UPIPayment = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const paymentData =
    location.state ||
    JSON.parse(localStorage.getItem("paymentData"));
  const { mockExamId, price, mockExamDesc } = paymentData || {};
  const amountInPaise = Math.round(price * 100);

  const markExamAsPaid = useCallback(() => {
    const paidExamIds = JSON.parse(localStorage.getItem("paidExamIds") || "[]");
    if (!paidExamIds.includes(mockExamId)) {
      localStorage.setItem("paidExamIds", JSON.stringify([...paidExamIds, mockExamId]));
    }
  }, [mockExamId]);

  const startPayment = useCallback(async () => {
    console.log("Pay button clicked");
    const loaded = await loadRazorpayScript();
    if (!loaded) {
      alert("Razorpay SDK failed to load");
      return;
    }

    console.log("Razorpay after load:", window.Razorpay);
    try {
      const res = await axios.post(CREATE_ORDER_API, null,
        {
          params: {
            amount: amountInPaise
          }
        }
      );
      console.log("Order API response:", res.data);
      const { orderId, amount, currency, key } = res.data;
      console.log("Razorpay object:", window.Razorpay);

      const options = {
        key,
        amount,
        currency,
        order_id: orderId,
        name: "For Inventralabs",
        description: mockExamDesc || "Mock Test Access",
        method: { upi: true },
        upi: { flow: "qr" },
        handler: async function (response) {
          //VERIFY PAYMENT
          const verifyRes = await axios.post(VERIFY_ORDER_API,
            {
              razorpay_order_id: response.razorpay_order_id,
              razorpay_payment_id: response.razorpay_payment_id,
              razorpay_signature: response.razorpay_signature
            }
          );
          if (verifyRes.data.status === "SUCCESS") {
            markExamAsPaid();
            navigate("/fullexamdisplay", {
              state: { ...paymentData, paid: true }
            });
          } else {
            alert("Payment verification failed");
          }
        },
        modal: {
          ondismiss: () => alert("Payment cancelled")
        },

        theme: { color: "#0a2540" }
      };
      console.log("OPTIONS 👉", options);
      const rzp = new window.Razorpay(options);
      rzp.open();

    } catch (error) {
      console.error("PAYMENT ERROR 👉", error);
      alert("Unable to start payment");
    }
  }, [amountInPaise, markExamAsPaid, mockExamDesc, navigate, paymentData]);

  // AUTO START PAYMENT ON LOAD
  useEffect(() => {
    if (!mockExamId || !price) {
      alert("Invalid payment data");
      navigate("/");
      return;
    }
    startPayment();
  }, [mockExamId, price, navigate, startPayment]);

  return (
    <div className="payment-center">
      <h2>Pay ₹{price} to Start Mock Test</h2>
      <h3>Redirecting to UPI payment...</h3>
    </div>
  );
};
export default UPIPayment;
